import { format } from "date-fns";

export const FullMonth = (fecha) => {
    var fechaFin = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0);
    
    return `${format(fecha, 'Y-M-dd').toString()},${format(fechaFin, 'Y-M-dd').toString()}`;
}